import LocationsSection from './sections/locations-section/locations-section.component';
import PoolLocationSection from './sections/pool-location-section/pool-location-section.component';
import { Stack } from '@mui/material';
import AuthorizationGate from 'components/authorization-gate/authorization-gate.component';
import { useListAchLocationsQuery } from 'api/giftcard-ach-service/giftcard-ach-service';
import partition from 'lodash.partition';

const MoneyMovementAccountConfiguration = () => {
  const {
    data: achLocations = [],
    isLoading,
    isFetching,
  } = useListAchLocationsQuery();

  const [poolLocation, nonPoolLocations] = partition(achLocations, loc =>
    loc.locationId.includes('POOL_ACCOUNT'),
  );

  return (
    <Stack spacing={2} marginTop={2}>
      <AuthorizationGate permission="ACH_PORTAL_VIEW_POOL_ACCOUNT">
        <PoolLocationSection
          locations={poolLocation}
          isLoading={isLoading || isFetching}
        />
      </AuthorizationGate>
      <LocationsSection
        locations={nonPoolLocations}
        isLoading={isLoading || isFetching}
      />
    </Stack>
  );
};

export default MoneyMovementAccountConfiguration;
